/* eslint-disable no-unused-expressions */
import i18n from '@/plugins/i18n';
const multiSelectFieldGenerator = formItemAttr => {
  const ranges = [];
  const multiDef = [];
  formItemAttr.attr.range.split(',').forEach((range) => {
    const select = range.split(':');
    ranges.push({
      name: select[0].trim(),
      value: select[0].trim()
    }); // MML需要文字描述
  });
  formItemAttr.defValue = formItemAttr.defValue !== null ? formItemAttr.defValue.split(':')[0].trim() : null;
  multiDef.push(formItemAttr.defValue);
  return {
    zname: formItemAttr.zname,
    ename: formItemAttr.ename,
    name: formItemAttr.name,
    plugin: 'multi-select',
    type: 'Enum',
    validate: formItemAttr.validate,
    vals: ranges,
    placeholder: '',
    def: multiDef,
    // TODO by s18857
    func: formItemAttr.func,
    asc: formItemAttr.index,
  };
};

const selectFieldGenerator = formItemAttr => {
  const ranges = [];
  formItemAttr.notNull === 'NO' && ranges.push({ name: '', value: '' });
  formItemAttr.attr.range.split(',').forEach((range) => {
    const select = range.split(':');
    ranges.push({
      name: select[0].trim(),
      value: select[0].trim()
    }); // MML需要文字描述
  });
  formItemAttr.defValue = formItemAttr.defValue !== null ? formItemAttr.defValue.split(':')[0].trim() : null;
  return {
    zname: formItemAttr.zname,
    ename: formItemAttr.ename,
    name: formItemAttr.name,
    plugin: 'form-select',
    type: 'Enum',
    validate: formItemAttr.validate,
    vals: ranges,
    placeholder: '',
    def: formItemAttr.defValue,
    // TODO by s18857
    func: formItemAttr.func,
    asc: formItemAttr.index,
  };
};

const boolFieldGenerator = formItemAttr => {
  const ranges = [];
  formItemAttr.notNull === 'NO' && ranges.push({ name: '', value: '' });
  formItemAttr.attr.range.split(',').forEach((range) => {
    const select = range.split(':');
    ranges.push({
      name: select[0].toLocaleLowerCase().trim(),
      value: select[0].toLocaleLowerCase().trim()
    }); // MML需要文字描述
  });
  formItemAttr.defValue = formItemAttr.defValue ? 'true' : 'false';
  return {
    zname: formItemAttr.zname,
    ename: formItemAttr.ename,
    name: formItemAttr.name,
    plugin: 'form-select',
    type: 'Enum',
    validate: formItemAttr.validate,
    vals: ranges,
    placeholder: '',
    def: formItemAttr.defValue,
    // TODO by s18857
    func: formItemAttr.func,
    asc: formItemAttr.index,
  };
};

const textFieldGenerator = formItemAttr => {
  const range = (parseInt(formItemAttr.attr.range, 0) - 1).toString();
  return {
    zname: formItemAttr.zname,
    ename: formItemAttr.ename,
    name: formItemAttr.name,
    plugin: formItemAttr.isForeign ? 'form-select' : null,
    type: 'Text',
    validate: formItemAttr.validate,
    placeholder: i18n.t('MML.maxBytesLength', [range]),
    def: formItemAttr.defValue,
    foreignKey: formItemAttr.attr.foreignKey,
    // TODO by s18857
    func: formItemAttr.func,
    isForeign: formItemAttr.isForeign,
    asc: formItemAttr.index,
  };
};

const ipv4FieldGenerator = formItemAttr => ({
  zname: formItemAttr.zname,
  ename: formItemAttr.ename,
  name: formItemAttr.name,
  plugin: formItemAttr.isForeign ? 'form-select' : null,
  type: 'Ipv4',
  validate: formItemAttr.validate,
  placeholder: i18n.t('MML.notValidIpv4'),
  def: formItemAttr.defValue,
  foreignKey: formItemAttr.attr.foreignKey,
  // TODO by s18857
  func: formItemAttr.func,
  isForeign: formItemAttr.isForeign,
  asc: formItemAttr.index,
});

const integerFieldGenerator = formItemAttr => {
  const range = formItemAttr.attr.range.split(',');
  for (let i = 0; i < range.length; i++) {
    range[i] = range[i].replace(/\(|\)/g, '');
  }
  // 当range[1]不存在时，将range[0]赋给range[1]
  if (!range[1]) {
    range[1] = range[0];
  }
  return {
    zname: formItemAttr.zname,
    ename: formItemAttr.ename,
    name: formItemAttr.name,
    plugin: formItemAttr.isForeign ? 'form-select' : null,
    type: 'Number',
    validate: formItemAttr.validate,
    placeholder: parseInt(range[0], 0) === parseInt(range[1], 0) ? range[0] : `${range[0]} ~ ${range[1]}`,
    def: formItemAttr.defValue,
    foreignKey: formItemAttr.attr.foreignKey,
    // TODO by s18857
    func: formItemAttr.func,
    isForeign: formItemAttr.isForeign,
    asc: formItemAttr.index,
  };
};

const fieldGenerator = {
  multienum: multiSelectFieldGenerator,
  enum: selectFieldGenerator,
  bool: boolFieldGenerator,
  text: textFieldGenerator,
  ipv4: ipv4FieldGenerator,
  default: integerFieldGenerator,
};
export default fieldGenerator;